/**
 * Royal Cart Logic (Safe Version)
 * Handles Product Page redirection and Drawer updates (only if Drawer exists)
 */

const drawer = document.getElementById('RoyalCartDrawer');
const itemsContainer = document.getElementById('RoyalCartItems');
const totalEl = document.getElementById('RoyalCartTotal');

// 1. Toggle Drawer (Only works if drawer exists)
function toggleRoyalCart(isOpen) {
  if (!drawer) return; // Safety check
  if (isOpen) {
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden'; 
    refreshRoyalCart(); 
  } else {
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }
}

// 2. Fetch & Render Cart
async function refreshRoyalCart() {
  // CRITICAL FIX: Stop if we are on the Cart Page (No Drawer elements)
  if (!itemsContainer) return; 

  try {
    const res = await fetch(window.Shopify.routes.root + 'cart.js');
    const cart = await res.json();
    
    if(totalEl) totalEl.innerText = formatMoney(cart.total_price);
    
    document.querySelectorAll('.cart-badge').forEach(b => {
      b.innerText = cart.item_count;
      b.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });

    if (cart.item_count === 0) {
      itemsContainer.innerHTML = `
        <div style="text-align:center; padding: 4rem 0; opacity:0.6;">
          <p style="font-family:'Cinzel', serif; font-size:1.2rem; color:#F0EAD6; margin-bottom:1rem;">Your archive is empty.</p>
          <a href="/collections/all" onclick="toggleRoyalCart(false)" style="text-decoration:underline; font-size:0.8rem; color:inherit;">Explore Collection</a>
        </div>`;
    } else {
      itemsContainer.innerHTML = cart.items.map(item => `
        <div class="rc-item">
          <div class="rc-item-img-box">
            <img src="${item.featured_image.url}" class="rc-item-img" alt="${item.product_title}">
          </div>
          <div class="rc-item-info">
            <a href="${item.url}" class="rc-item-title">${item.product_title}</a>
            ${item.variant_title ? `<span class="rc-item-variant">${item.variant_title}</span>` : ''}
            <div class="rc-item-bottom">
              <span class="rc-item-price">${formatMoney(item.price)}</span>
              <div class="rc-qty-controls">
                <button type="button" onclick="changeRoyalQty('${item.key}', ${item.quantity - 1})">-</button>
                <span>${item.quantity}</span>
                <button type="button" onclick="changeRoyalQty('${item.key}', ${item.quantity + 1})">+</button>
              </div>
            </div>
            <button type="button" class="rc-item-remove" onclick="changeRoyalQty('${item.key}', 0)">Remove</button>
          </div>
        </div>
      `).join('');
    }
  } catch (error) {
    console.error('Error refreshing cart:', error);
  }
}

// 3. Main Add-to-Cart Listener (Redirects to Cart Page)
document.addEventListener('submit', async function(e) {
  const form = e.target;
  const action = form.getAttribute('action');

  if (action && action.includes('/cart/add')) {
    e.preventDefault();
    
    const submitBtn = form.querySelector('[type="submit"]');
    const originalText = submitBtn ? submitBtn.innerText : 'Add';

    if(submitBtn) {
      submitBtn.disabled = true;
      submitBtn.innerText = "Adding to cart...";
    }

    try {
      const formData = new FormData(form);
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: formData
      });

      if (response.ok) {
        // SUCCESS: Go to Cart Page
        window.location.href = window.Shopify.routes.root + 'cart';
      } else {
        alert("Item could not be added.");
      }
    } catch (err) {
      console.error(err);
    } finally {
      if(submitBtn) {
        submitBtn.disabled = false;
        submitBtn.innerText = originalText;
      }
    }
  }
});

// 4. Change Quantity (Only used by Drawer, not Page)
async function changeRoyalQty(key, newQty) {
  try {
    await fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: newQty })
    });
    refreshRoyalCart();
  } catch (err) {
    console.error(err);
  }
}

function formatMoney(cents) {
  return 'Dhs. ' + (cents / 100).toFixed(2);
}

document.addEventListener("DOMContentLoaded", refreshRoyalCart);